<div class="row game-wrapper">
  <!--   [style.background]="'url('+game.img+')'" -->
  <!-- poster="" muted="muted" preload="auto" loop="" autoplay="" -->
  <video autoplay muted loop id="myVideo" *ngIf="url==='incendios-forestales'">
    <source src="/assets/video-incendios-01.mp4" type="video/mp4">
    Your browser does not support HTML5 video.
  </video>
  <video autoplay muted loop id="myVideo" *ngIf="url==='humedales'">
    <source src="/assets/video-humedales-01.mp4" type="video/mp4">
    Your browser does not support HTML5 video.
  </video>

  <div class="game-header p90" style="padding-right: 30px !important;">
    <h3 class="title">{{title}}</h3>
    <p class="game-home-link">
      <a href="/conoce-la-naturaleza">
        <span class="glyphicon glyphicon-menu-left"></span>
        Explora otros juegos y recursos</a>
    </p>
  </div>
  <app-game-tutorial #appGameTutorial></app-game-tutorial>

  <a href="{{'juego-info/'+url+'/'+cat.name}}" class="game-cta child-{{i}} btn-blink"
    *ngFor="let cat of categories; let i = index">

    <svg *ngIf="url==='incendios-forestales'" xmlns="http://www.w3.org/2000/svg" width="87" height="87"
      viewBox="0 0 87 87">
      <g id="Grupo_113" data-name="Grupo 113" transform="translate(-137 -299)">
        <path id="Trazado_47" data-name="Trazado 47"
          d="M171.413,52.333A30.583,30.583,0,1,0,202,82.916,30.618,30.618,0,0,0,171.413,52.333Zm9.324,49.066a33.589,33.589,0,0,1-3.135,2.083,37.064,37.064,0,0,0,2.264-5.849c.543-2.534-.491-4.868-2-6.943a25.767,25.767,0,0,1-2.621-3.676c-.963-1.992-1.615-4.135-2.421-6.27-4.121,3.4-5.043,8.155-4.716,13.562-2.339-1.09-2.532-3.072-2.775-5.035-3.426,3.362-3.269,9.987.31,14.053-1.791-.272-4.373-2.214-6.033-4.539a15.529,15.529,0,0,1,.092-17.879c1.228-1.829,2.62-3.551,3.965-5.3A20.166,20.166,0,0,0,168.15,63.4a3.838,3.838,0,0,1,.06-.642c.017-.094.105-.174.254-.4,6.976,4.194,10.54,10.3,10.535,18.5l.531.178,2.352-3.946C186.317,83.371,188.781,94.818,180.737,101.4Z"
          transform="translate(9.003 259.583)" fill="#fff" />
      </g>
    </svg>

    <svg *ngIf="url==='humedales'" xmlns="http://www.w3.org/2000/svg" width="141" height="141" viewBox="0 0 141 141">
      <g id="Grupo_114" data-name="Grupo 114" transform="translate(-304.83 -207)">
        <g id="Grupo_114-2" data-name="Grupo 114">
          <path id="Trazado_49" data-name="Trazado 49"
            d="M375.33,348a70.5,70.5,0,1,1,70.5-70.5A70.58,70.58,0,0,1,375.33,348Zm0-134a63.5,63.5,0,1,0,63.5,63.5A63.572,63.572,0,0,0,375.33,214Z"
            fill="#fff" />
        </g>
        <path id="Trazado_50" data-name="Trazado 50"
          d="M373.991,326c-2-.252-4.039-.347-6-.782a35.978,35.978,0,0,1-25.2-19.247,35.058,35.058,0,0,1-3.752-12.415,42.6,42.6,0,0,1,2.15-18.1A82.393,82.393,0,0,1,352.86,253.29a145.672,145.672,0,0,1,20.663-23.075c1.747-1.6,1.774-1.627,3.521-.043a152.378,152.378,0,0,1,13.992,14.45,117.452,117.452,0,0,1,12.715,18,64.294,64.294,0,0,1,7.025,17.671,39.121,39.121,0,0,1,.824,13.368,36.638,36.638,0,0,1-29.5,31.7c-1.787.36-3.631.437-5.449.644Zm19.7-56.44c1.311,18.967-5.93,33.581-21.7,44.039.8.077,1.548.194,2.3.215a24.375,24.375,0,0,0,11.974-2.6A23.979,23.979,0,0,0,397,300.491a24.561,24.561,0,0,0,2.3-15.248A49.976,49.976,0,0,0,393.7,269.56Z"
          fill="#fff" />
      </g>
    </svg>

    <div class="tt">{{cat.title.es}}
      <div class="arrow-down"></div>
    </div>
  </a>


  <a [class.closed]="!toolkit" href="{{'juego-glosario/'+url+'/todas'}}" class="btn-theme game-btn glossary">
    <svg xmlns="http://www.w3.org/2000/svg" width="25.188" height="31" viewBox="0 0 25.188 31">
      <g id="bookmarks-sharp" transform="translate(-48)">
        <path id="Trazado_55" data-name="Trazado 55" d="M112,0V2.906h18.406V25.188l2.906,1.938V0Z"
          transform="translate(-60.125)" fill="#fff" />
        <path id="Trazado_56" data-name="Trazado 56" d="M48,80v26.156l10.172-7.508,10.172,7.508V80Z"
          transform="translate(0 -75.156)" fill="#fff" />
      </g>
    </svg>
    <span>Glosario</span>
  </a>
  <a [class.closed]="!toolkit" href="{{'juego-recursos/'+url+'/9'}}" class="btn-theme game-btn resources">
    <svg xmlns="http://www.w3.org/2000/svg" width="35.246" height="37.764" viewBox="0 0 35.246 37.764">
      <g id="file-tray-stacked-sharp" transform="translate(-32 -16)">
        <path id="Trazado_40" data-name="Trazado 40"
          d="M64.729,16H34.518L32,28.588V39.917H67.246V28.588Zm-.944,12.588H54.658a5.035,5.035,0,0,1-10.07,0H35.462L37.193,19.3H62.054Z"
          fill="#fff" />
        <path id="Trazado_41" data-name="Trazado 41" d="M54.658,352a5.035,5.035,0,0,1-10.07,0H32v11.329H67.246V352Z"
          transform="translate(0 -309.565)" fill="#fff" />
      </g>
    </svg>

  </a>
  <a [class.closed]="!toolkit" href="{{'login'}}" *ngIf="!user.isLogued()"
    class="btn-theme ts-background-4 game-btn user">
    <svg xmlns="http://www.w3.org/2000/svg" width="32.456" height="34.952" viewBox="0 0 32.456 34.952">
      <g id="person" transform="translate(-47.994 -32)">
        <path id="Trazado_42" data-name="Trazado 42"
          d="M166.092,34.542a8.336,8.336,0,0,0-11.971-.016,8.258,8.258,0,0,0-2.1,6.3c.346,4.768,3.975,8.647,8.089,8.647s7.736-3.878,8.088-8.646A8.234,8.234,0,0,0,166.092,34.542Z"
          transform="translate(-95.891)" fill="#fff" />
        <path id="Trazado_43" data-name="Trazado 43"
          d="M77.953,302.979H50.491a2.419,2.419,0,0,1-1.888-.868,2.755,2.755,0,0,1-.56-2.271,13.358,13.358,0,0,1,5.943-8.875,19.153,19.153,0,0,1,20.472,0,13.354,13.354,0,0,1,5.943,8.874,2.755,2.755,0,0,1-.56,2.271A2.418,2.418,0,0,1,77.953,302.979Z"
          transform="translate(0 -236.028)" fill="#fff" />
      </g>
    </svg>
  </a>
  <a [class.closed]="!toolkit" href="{{'juego-crear'}}" *ngIf="user.isLogued()"
    class="btn-theme ts-background-4 game-btn user">
    <svg xmlns="http://www.w3.org/2000/svg" width="32.456" height="34.952" viewBox="0 0 32.456 34.952">
      <g id="person" transform="translate(-47.994 -32)">
        <path id="Trazado_42" data-name="Trazado 42"
          d="M166.092,34.542a8.336,8.336,0,0,0-11.971-.016,8.258,8.258,0,0,0-2.1,6.3c.346,4.768,3.975,8.647,8.089,8.647s7.736-3.878,8.088-8.646A8.234,8.234,0,0,0,166.092,34.542Z"
          transform="translate(-95.891)" fill="#fff" />
        <path id="Trazado_43" data-name="Trazado 43"
          d="M77.953,302.979H50.491a2.419,2.419,0,0,1-1.888-.868,2.755,2.755,0,0,1-.56-2.271,13.358,13.358,0,0,1,5.943-8.875,19.153,19.153,0,0,1,20.472,0,13.354,13.354,0,0,1,5.943,8.874,2.755,2.755,0,0,1-.56,2.271A2.418,2.418,0,0,1,77.953,302.979Z"
          transform="translate(0 -236.028)" fill="#fff" />
      </g>
    </svg>
  </a>
  <a [class.closed]="!toolkit" href="{{'juego-trivia/'+url}}" class="btn-theme ts-background-4 game-btn play">
    Jugar
    <svg *ngIf="url==='incendios-forestales'" xmlns="http://www.w3.org/2000/svg" width="80" height="80"
      viewBox="0 0 80 80">
      <g id="Grupo_101" data-name="Grupo 101" transform="translate(-140.657 -207.16)">
        <ellipse id="Elipse_23" data-name="Elipse 23" cx="39.96" cy="39.96" rx="39.96" ry="39.96"
          transform="translate(140.657 207.16)" fill="#F07D00" />
        <path id="Trazado_38" data-name="Trazado 38"
          d="M192.906,230.427c9.114,5.47,13.769,13.437,13.762,24.138l.694.232,3.072-5.147c5.795,8.2,9.014,23.128-1.494,31.713a43.9,43.9,0,0,1-4.1,2.717c.983-2.45,2.383-4.951,2.958-7.63.71-3.305-.642-6.35-2.614-9.057a33.65,33.65,0,0,1-3.424-4.8c-1.258-2.6-2.11-5.394-3.162-8.179-5.383,4.435-6.588,10.638-6.161,17.692-3.056-1.422-3.307-4.007-3.626-6.568-4.476,4.385-4.27,13.028.4,18.331-2.34-.354-5.712-2.888-7.881-5.92-4.873-6.814-4.869-15.9.121-23.322,1.6-2.386,3.422-4.632,5.18-6.913A26.282,26.282,0,0,0,192.5,231.79a5,5,0,0,1,.079-.838C192.6,230.83,192.712,230.725,192.906,230.427Z"
          transform="translate(-16.015 -10.006)" fill="#fff" />
        <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
          <path id="Trazado_39" data-name="Trazado 39"
            d="M180.744,287.16a39.914,39.914,0,1,1,39.914-39.914A39.959,39.959,0,0,1,180.744,287.16Zm0-75.864a35.951,35.951,0,1,0,35.951,35.951A35.991,35.991,0,0,0,180.744,211.3Z"
            transform="translate(-140.83 -207.333)" fill="#fff" />
        </g>
      </g>
    </svg>

    <svg style="background: #f07d00;
    border-radius: 50%;" *ngIf="url==='humedales'" xmlns="http://www.w3.org/2000/svg" width="80" height="80"
      viewBox="0 0 141 141">
      <g id="Grupo_114" data-name="Grupo 114" transform="translate(-304.83 -207)">
        <g id="Grupo_114-2" data-name="Grupo 114">
          <path id="Trazado_49" data-name="Trazado 49"
            d="M375.33,348a70.5,70.5,0,1,1,70.5-70.5A70.58,70.58,0,0,1,375.33,348Zm0-134a63.5,63.5,0,1,0,63.5,63.5A63.572,63.572,0,0,0,375.33,214Z"
            fill="#fff" />
        </g>
        <path id="Trazado_50" data-name="Trazado 50"
          d="M373.991,326c-2-.252-4.039-.347-6-.782a35.978,35.978,0,0,1-25.2-19.247,35.058,35.058,0,0,1-3.752-12.415,42.6,42.6,0,0,1,2.15-18.1A82.393,82.393,0,0,1,352.86,253.29a145.672,145.672,0,0,1,20.663-23.075c1.747-1.6,1.774-1.627,3.521-.043a152.378,152.378,0,0,1,13.992,14.45,117.452,117.452,0,0,1,12.715,18,64.294,64.294,0,0,1,7.025,17.671,39.121,39.121,0,0,1,.824,13.368,36.638,36.638,0,0,1-29.5,31.7c-1.787.36-3.631.437-5.449.644Zm19.7-56.44c1.311,18.967-5.93,33.581-21.7,44.039.8.077,1.548.194,2.3.215a24.375,24.375,0,0,0,11.974-2.6A23.979,23.979,0,0,0,397,300.491a24.561,24.561,0,0,0,2.3-15.248A49.976,49.976,0,0,0,393.7,269.56Z"
          fill="#fff" />
      </g>
    </svg>
  </a>
  <a [class.closed]="!toolkit" (click)="appGameTutorial.openSearch()"
    class="btn-theme ts-background-black game-btn help">
    <span>?</span>
  </a>

  <a [class.open]="toolkit" (click)="showToolkit()" class="btn-theme game-btn options ts-background-4">
    <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
      <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)"
        fill="#fff" />
    </svg>
  </a>
</div>
